import * as React from 'react';
import Utils from '../../../../utils';

import { ActionType } from '../index';
import { Button } from './styles';

interface ActionButtonProps {
	type: ActionType;
	onClick: (() => void) | Function;
	isInverted?: boolean;
	isDisabled?: boolean;
}

interface IconConfig {
	name: string;
	width: string;
	height: string;
}

const getIcons = (type: ActionType): { icon: IconConfig, invertedIcon?: IconConfig } => {
	switch (type) {
		case ActionType.EDIT_LINK:
			return {
				icon: {
					name: 'iconset_uprez_link2',
					width: '22px',
					height: '22px',
				},
			};
		case ActionType.RUN_INDESIGN_ACTION:
			return {
				icon: {
					name: 'iconset_uprez_pointer',
					width: '16px',
					height: '19px',
				},
			};
		case ActionType.TOGGLE_BUTTON_STATE:
			return {
				icon: {
					name: 'iconset_uprez_multistate',
					width: '18px',
					height: '19px',
				},
			};
		case ActionType.TOGGLE_VISIBILITY:
			return {
				icon: {
					name: 'iconset_uprez_eye',
					width: '21px',
					height: '14px',
				},
				invertedIcon: {
					name: 'iconset_uprez_eye_crossed',
					width: '21px',
					height: '17px',
				},
			};
	}
};

const ActionButton = ({
	type,
	onClick,
	isInverted,
	isDisabled,
}: ActionButtonProps) => {
	const { icon, invertedIcon } = getIcons(type);
	const { name, width, height } = isInverted ? invertedIcon! : icon;

	return (
		<Button
			iconWidth={width}
			iconHeight={height}
			isInverted={isInverted}
			disabled={isDisabled}
			onClick={onClick}
		>
			{Utils.getSvgIcon(name)}
		</Button>
	);
};

export default ActionButton;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ActionsPanel/ActionButton/index.tsx